function faqTabs() {
  const handlers = document.querySelectorAll(".faq-handler");
  const panels = document.querySelectorAll(".faq-panel");

  if (!panels || !handlers) return;

  function activateTab(element) {
    if (!element) return;

    element.classList.replace("bg-white", "bg-black");
    element.classList.replace("text-black", "text-white");
  }

  function deActivateTab(element) {
    if (!element) return;

    element.classList.replace("bg-black", "bg-white");
    element.classList.replace("text-white", "text-black");
  }

  function activatePanel(element) {
    if (!element) return;

    element.classList.replace("grid-rows-[0fr]", "grid-rows-[1fr]");
  }

  function deActivatePanel(element) {
    if (!element) return;

    element.classList.replace("grid-rows-[1fr]", "grid-rows-[0fr]");
  }

  activateTab(handlers[0]);
  activatePanel(panels[0]);

  handlers.forEach((handler) => {
    handler.addEventListener("click", () => {
      //disable others handlers
      handlers.forEach((innerHandler) => deActivateTab(innerHandler));

      //enable clicked handler
      activateTab(handler);

      //enable related panel
      panels.forEach((panel) => {
        const isRelatedPanel =
          panel.getAttribute("controlled-by") === handler.id;

        if (isRelatedPanel) {
          activatePanel(panel);
        } else {
          deActivatePanel(panel);
        }
      });
    });
  });
}

function faqCard() {
  const faqCards = document.querySelectorAll(".faq-card");
  if (!faqCards) return;

  function activateFaq(faq, expert) {
    expert.classList.replace("grid-rows-[0fr]", "grid-rows-[1fr]");
    faq
      .querySelector("span")
      ?.classList.add(
        "rotate-180",
        "text-background-main",
        "bg-secondary-dark"
      );
    faq.querySelector(".faq-expert")?.classList.add("pt-4");
  }

  function deActivateFaq(faq, expert) {
    expert.classList.replace("grid-rows-[1fr]", "grid-rows-[0fr]");
    faq
      .querySelector("span")
      ?.classList.remove(
        "rotate-180",
        "text-background-main",
        "bg-secondary-dark"
      );
    faq.querySelector(".faq-expert")?.classList.remove("pt-4");
  }

  faqCards.forEach((faq) => {
    const faqToggle = faq.querySelector(".faq-toggle");
    const expert = faq.querySelector(".faq-expert");
    if (!expert) return;

    faqToggle?.addEventListener("click", () => {
      const faqIsActive = expert.classList.contains("grid-rows-[1fr]");

      if (faqIsActive) {
        deActivateFaq(faq, expert);
      } else {
        activateFaq(faq, expert);
      }
    });
  });
}

faqTabs();
faqCard();
